// extracted by mini-css-extract-plugin
module.exports = {"card":"BlockCard_card__e74Qy","header":"BlockCard_header__DmLb_","title":"BlockCard_title___8CJM","actions":"BlockCard_actions__CB5DW","body":"BlockCard_body___Z8i3"};